import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import AddSecurityCodeForm from './AddSecurityCodeForm';
import { addUserChange } from '../actions/Users';
import { changeAction } from '../actions/BoxSessionLogging';
import { addSystemLogs } from '../actions/SystemLogs';
import { securityPinActivities, PIN_CODES_LIST, multiCodeFeature } from '../utils/constants';
import utils from '../lib/utils';

/* MULTI CODE HINT */
/* FOR MULTI-CODE - send boolean based on whose multicode you are going to send */
/* EXAMPLE: for enableDisable => send multicode = {!!isEnableDisable} in prop */

/** toggle button component
 * @param {boolean} isOpen - show or hide the modal
 * @param {string} securityCode - security code string from user
 * @param {boolean} multiCode - to enable multicode acceptance or single
 * @param {boolean} diagnostics - to enable DIAGNOSTICS specific code
 */

const AddSecurityCodeModal = ({
  isOpen,
  onConfirm,
  onCancel,
  addUserChange,
  securityCode,
  onWrongCode,
  addSystemLogs,
  user,
  featureName,
  multiCode
}) => {
  // console.log("Got DC auto update featureName", featureName, PIN_CODES_LIST[featureName])
  const onConfirmPress = () => {

    let validCheck;
    let pinCode = PIN_CODES_LIST[featureName];
    if (!pinCode) {
      pinCode = PIN_CODES_LIST['default'];
    }
    validCheck = securityCode === pinCode;

    if (!validCheck && multiCodeFeature.includes(featureName)) {
      pinCode = PIN_CODES_LIST['multiCode'];
      validCheck = pinCode.includes(securityCode)
    }

    if (validCheck) {
      onConfirm();
      addUserChange({ name: 'security', value: '' });
      let activity = securityPinActivities[featureName];
      if (activity == undefined || activity == 'undefined') {
        activity = featureName;
      }
      
      console.log(`activity_log______ featureName: ${featureName} `);
      const body = {
        actionType: 'system',
        description: `User ${user.name} perform '${activity}' at ${utils.getDateTimeFormat(new Date(), 'regular')}`,
      };
      const token = localStorage.getItem('jwtToken') || null;
      addSystemLogs(token, body)
    } else {
      toast.error('Wrong security code.');
      if (onWrongCode) onWrongCode();
    }
  };
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Enter Security Code</ModalHeader>
      <ModalBody>
        <AddSecurityCodeForm />
      </ModalBody>
      <ModalFooter>
        <Button
          outline
          onClick={e => {
            addUserChange({ name: 'security', value: '' });
            onCancel(e);
          }}
        >
          Cancel
        </Button>
        <Button color="primary" onClick={onConfirmPress} id="security-submit-btn">
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapDispatchToProps = dispatch => ({
  addUserChange: userData => dispatch(addUserChange(userData)),
  addSystemLogs: (token, body) => dispatch(addSystemLogs(token, body)),
});

const mapStateToProps = store => ({
  securityCode: store.UIState.users.addedUser.security,
  user: store.AppState.user,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddSecurityCodeModal);
